import React from 'react';
import logo from '../KunudsenLogo.png'
import { FaPhone, FaMailBulk } from "react-icons/fa";
export default function Header() {
    return (
        <div className='Header'>
            <div className="Logo">
                <img src={logo} style={{ height: "100%" }}></img>

            </div>
            <div className="BusinessName">
                <p>KNUDSEN <hr></hr>INSURANCE AGENCY</p>
            </div>
            <div className="HeaderContactInfo">
                <a className="PhoneLink" href="tel:4352627460">
                    <FaPhone fill="white" stroke='black' strokeWidth="10px" size={40}></FaPhone>
                </a>
                <a className="EmailLink" href="mailto:knudsen.insurance@gmail.com">
                    <FaMailBulk fill="white" stroke='black' strokeWidth="2px" size={40}></FaMailBulk>
                </a>
            </div>
        </div>
    );
}